import activity from './activity'
import common from './common'
import landingPage from './landing-page'

export default [
    ...activity,
    ...common,
    ...landingPage
]